import cookie from 'js-cookie';
import queryString from 'query-string';

import { OrderDeclineType } from 'types/enums/OrderDeclineType';

import { assertString } from 'helpers/utils/checkType';

import { INSUFFICIENT_CREDITS_ERROR_CODE } from './constants';

type IntentUrlSearchParams = {
  orderId: string;
  status: string;
};

export const sortPackagesByOrder = <T extends { display_order: number }>(
  packages: T[]
): T[] => {
  return [...packages].sort((a, b) => a.display_order - b.display_order);
};

export const getSearchStringFromUrl = (url: string) => url.split('?')[1] ?? '';

export const getIntentUrlSearchParams = (
  url?: string
): Partial<IntentUrlSearchParams> => {
  if (!assertString(url)) {
    return {
      orderId: undefined,
      status: undefined,
    };
  }

  const { order_id: orderId, status } = queryString.parse(
    getSearchStringFromUrl(url)
  );

  return {
    orderId: assertString(orderId) ? orderId : undefined,
    status: assertString(status) ? status : undefined,
  };
};

export const getIsInsufficientCreditError = (code?: string) => {
  return code && code === INSUFFICIENT_CREDITS_ERROR_CODE;
};

const DECLINE_TYPE_COOKIE_NAME = 'payment_decline_type';

const assertDeclineType = (prop: unknown): prop is OrderDeclineType => {
  return (
    prop === OrderDeclineType.Retryable ||
    prop === OrderDeclineType.Final ||
    prop === OrderDeclineType.MethodFinal
  );
};

export const getDeclineTypeTestCookie = () => {
  const maybeDeclineType = cookie.get(DECLINE_TYPE_COOKIE_NAME);

  return assertDeclineType(maybeDeclineType) ? maybeDeclineType : undefined;
};
